// @ts-nocheck
import { OUTLINED_BORDER_SX } from '../constants';

import type { ReactNode } from 'react';
import type { SxProps, Theme } from '@mui/material/styles';

export function hasRenderableHelperText(helperText: ReactNode | undefined): boolean {
  if (
    helperText === undefined ||
    helperText === null ||
    helperText === true ||
    helperText === false ||
    helperText === ''
  ) {
    return false;
  }
  return true;
}

export function mergeSx(...sxProps: Array<SxProps<Theme> | undefined>): SxProps<Theme> {
  return sxProps.flatMap((sx) => {
    if (sx == null) {
      return [];
    }
    return Array.isArray(sx) ? sx : [sx];
  });
}

export function mergeSxWithOutlinedBorder(sx: SxProps<Theme> | undefined): SxProps<Theme> {
  if (sx === undefined || sx === null) {
    return OUTLINED_BORDER_SX;
  }
  return mergeSx(OUTLINED_BORDER_SX, sx);
}

export function buildRelativeContainerSx(fullWidth: boolean | undefined): SxProps<Theme> {
  return {
    position: 'relative',
    display: fullWidth ? 'block' : 'inline-block',
    width: fullWidth ? '100%' : 'auto',
    '& .ant-picker-input > input': { fontSize: 14 },
  };
}
